import { FormControl, Grid, TextField } from "@mui/material";

import { memo, useEffect, useRef, useState } from "react";

import { FieldError } from "@components/FieldError";
import { IFormControlProperty } from "@definitions/index";
import { customDisabledOutlineInput, flexCenterProps, paddingX1Props } from "@styles/global-css-class";
import DiffInheritanceIndicator from "@components/DiffInheritanceIndicator";

function NewMultilineTextFormControl({
	childKey,
	label,
	name,
	value,
	defaultValue,
	placeHolder,
	onChange,
	isRequired,
	isDisabled,
	isHidden = false,
	formState,
	xsFormControl = 12,
	mdFormControl = 12,
	xsLabel = 0,
	xsInput,
	textAlign,
	textErrorAlign,
	itemSx,
	textSx,
	isExpanded,
	errorName,
	showIndicator,
	isIndicatorTakeSpace,
	...props
}: Readonly<IFormControlProperty>) {
	const inputRef = useRef<HTMLInputElement>(null);
	const [valueInput, setValueInput] = useState<string | null | undefined>(value ?? defaultValue ?? '');

	useEffect(() => {
		setValueInput(value ?? '');
	}, [value]);

	useEffect(() => {
		if (isExpanded && inputRef.current) {
			inputRef.current?.focus();
		}
	}, [isExpanded, inputRef.current])

	return <Grid container item xs={xsFormControl} md={mdFormControl} sx={itemSx ?? {
		...paddingX1Props,
		alignContent: 'flex-start'
	}}>
		<FormControl key={`${childKey}-form-control`} fullWidth margin='normal' {...props}>
			<Grid container item xs={xsInput ?? (xsLabel === 12 ? 12 : 12 - xsLabel)} sx={{ position: "relative" }} flexWrap={'nowrap'}>
				<Grid item xs={isIndicatorTakeSpace?11:12} >
					<TextField
						key={`${childKey}-form-control-input`}
						id={name}
						name={name}
						inputProps={{ ref: inputRef }}
						value={valueInput}
						onChange={(e) => {
							setValueInput(e.target.value)
						}}
						onBlur={(e) => {
							onChange(e.target.value);
						}}
						placeholder={placeHolder}
						error={formState?.errors[errorName ?? name] !== undefined}
						required={isRequired}
						disabled={isDisabled ?? false}
						hidden={isHidden}
						type="text"
						multiline
						rows={3}
						label={label}
						sx={{
							width: "100%",
							...customDisabledOutlineInput
						}}
					/>
					{formState && <FieldError key={`${childKey}-form-control-error`} formState={formState} name={errorName ?? name} textAlign={textErrorAlign} />}
				</Grid>
				{showIndicator !== undefined && showIndicator() == true &&
					<Grid item xs={isIndicatorTakeSpace?1:0} sx={{ ...flexCenterProps }}>
						<DiffInheritanceIndicator />
					</Grid>
				}
			</Grid>
		</FormControl >
	</Grid >;
};

export default memo(NewMultilineTextFormControl);
